import { render, staticRenderFns } from "./DetailMenu.vue?vue&type=template&id=b8ec0932&"
import script from "./DetailMenu?vue&type=script&lang=js&"
export * from "./DetailMenu?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports